import { CloudUploadOutlined, DonutLarge } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AssetStateChart } from '@/components/AssetStateChart/AssetStateChart';
import { AssetStateChartSkeleton } from '@/components/AssetStateChart/AssetStateChartSkeleton';
import { BodyText } from '@/components/BodyText';
import { AssetState, AssetStateCountsResponse } from '@/api/generatedApi';
import { useTenants } from '@/services/tenants/useTenants';
import { DashboardTile } from './DashboardTile';
import { TileEmptyState } from './TileEmptyState';
import { useUploadAssetsAction } from './useUploadAssetsAction';

export const IngestionStatusTile = ({
  assetStateCounts,
  assetsTotal,
  isLoading,
  isError,
}: {
  assetStateCounts?: AssetStateCountsResponse;
  assetsTotal: number;
  isLoading: boolean;
  isError: boolean;
}) => {
  const navigate = useNavigate();
  const { getPath } = useTenants();
  const uploadAssetsAction = useUploadAssetsAction();

  return (
    <DashboardTile id='ingestion-status' title='Ingestion Status' icon={<DonutLarge />} to={getPath('status')}>
      {isError && <BodyText color='text.secondary'>Failed to load asset state counts.</BodyText>}
      {!isError && (isLoading || !assetStateCounts) && <AssetStateChartSkeleton />}
      {/* A donut of nothing is worse than saying there is nothing. */}
      {!isError && !isLoading && assetStateCounts && assetsTotal === 0 && (
        <TileEmptyState
          testId='no-assets-to-index'
          graphic={<CloudUploadOutlined />}
          title='Nothing to index yet'
          description='Uploaded parts are indexed so you can search them. Progress shows here.'
          action={uploadAssetsAction}
        />
      )}
      {!isError && !isLoading && assetStateCounts && assetsTotal > 0 && (
        <AssetStateChart
          data={assetStateCounts}
          assetsTotal={assetsTotal}
          showLegendAsLinks
          onStateClick={(assetState: AssetState) => {
            navigate(`${getPath('status')}?state=${assetState}`);
          }}
        />
      )}
    </DashboardTile>
  );
};
